module.exports = __webpack_public_path__ + "img/presentacion.622bdb5f.jpg";